import dayjs from "dayjs"
import { getServerUrl } from "../utils"
import { axiosCall } from "../utils/axiosUtils"

/**
 * KFC-598: the production days of a substitution, as the server expects them
 * @param {{startDate: number|string, endDate: number|string}} substitution dates stored at the UTC midnight (or end of day) of the production day
 * @returns {{startDate: string, endDate: string}} YYYY-MM-DD
 */
export const getSubstitutionProductionDays = (substitution) => ({
	startDate: dayjs.utc(substitution.startDate).format("YYYY-MM-DD"),
	endDate: dayjs.utc(substitution.endDate).format("YYYY-MM-DD")
})

/**
 * KFC-598: recipes produced between two production days that contain a supplier item, one row per recipe and production day
 * @param {{supplierItemId: string, startDate: string, endDate: string}} params production days as YYYY-MM-DD
 * @returns {Promise<{brands: Array<{name: string, label: string}>, rows: Array<Object>, recipesCount: number}>}
 */
export const getSupplierItemRecipes = async ({ supplierItemId, startDate, endDate }) => {
	const response = await axiosCall(
		"POST",
		`${getServerUrl()}/productionItems/_supplierItemRecipes`,
		{ supplierItemId, startDate, endDate },
		{ "Content-Type": "application/json" }
	)

	return response.data.data
}
